export default __webpack_public_path__ + "static/media/icons8-report.0c19b54f.svg";